import React from "react";
import { useAdminData } from "./useAdminData";
import { Panel, Skeleton, ErrorState, PageHeader, fmtNum } from "./Primitives";

// Catalog entities merged with real aggregated events, ranked by activity.
export default function EntityRanking({ title, meta, field, items, nameHeader, renderName, extraCols = [], testid }) {
  const { data, loading, error, reload } = useAdminData(async (api) => {
    const { data } = await api.get("/admin/breakdown", { params: { field } });
    const map = Object.fromEntries((data.rows || []).map((r) => [r.key, r]));
    return items
      .map((it) => ({ ...it, ...(map[it.id] || { clicks: 0, exit_clicks: 0, game_opens: 0, signal_views: 0, total: 0 }) }))
      .sort((a, b) => b.total - a.total);
  }, [field]);

  return (
    <div data-testid={`${testid}-page`}>
      <PageHeader title={title} meta={meta}><span className="text-[12px] text-[var(--muted2)]">Catálogo somente leitura · período total</span></PageHeader>
      {error && <ErrorState message={error} onRetry={reload} />}
      <Panel>
        {loading && !data ? <div className="p-4 space-y-2">{[0, 1, 2, 3, 4].map((i) => <Skeleton key={i} className="h-9" />)}</div> : data && (
          <div className="overflow-x-auto mia-scroll">
            <table className="ops-table" data-testid={`${testid}-table`}>
              <thead><tr>
                <th className="w-8">#</th><th>{nameHeader}</th>
                {extraCols.map((c) => <th key={c.key} className="!text-right">{c.label}</th>)}
                <th className="!text-right">Aberturas</th><th className="!text-right">Sinais</th>
                <th className="!text-right">Saídas</th><th className="!text-right">Cliques</th>
              </tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={r.id} className="mia-row">
                    <td className="mono text-[var(--muted2)]">{r.total ? i + 1 : "—"}</td>
                    <td>{renderName(r)}</td>
                    {extraCols.map((c) => <td key={c.key} className="num text-[var(--muted)]">{fmtNum(r[c.key])}</td>)}
                    <td className="num">{fmtNum(r.game_opens)}</td>
                    <td className="num">{fmtNum(r.signal_views)}</td>
                    <td className="num">{fmtNum(r.exit_clicks)}</td>
                    <td className="num text-[var(--muted)]">{fmtNum(r.clicks)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
